import React from 'react'
import { treeInitialState, treeReducer, ACTIONS } from './TreeReducer'

const TreeStateContext = React.createContext()
const TreeDispatchContext = React.createContext()

function useTreeState() {
  const context = React.useContext(TreeStateContext)
  if (context === undefined) {
    throw new Error('useTreeState must be used inside of TreeProvider')
  }
  return context
}

function useTreeDispatch() {
  const context = React.useContext(TreeDispatchContext)
  if (context === undefined) {
    throw new Error('useTreeDispatch must be used inside of TreeProvider')
  }
  return context
}

function TreeProvider({ children }) {
  const [treeGlobalState, treeGlobalDispatch] = React.useReducer(treeReducer, treeInitialState)

  return (
    <TreeStateContext.Provider value={treeGlobalState}>
      <TreeDispatchContext.Provider value={treeGlobalDispatch}>{children}</TreeDispatchContext.Provider>
    </TreeStateContext.Provider>
  )
}

export { TreeProvider, useTreeDispatch, useTreeState, ACTIONS }
